const ServerAPIUrl = "https://api.synergybot.io"
const ServerBaseAPIUrl = "api.synergybot.io"
// const ServerAPIUrl = "http://localhost:3001"
// const ServerAPIUrl = "http://116.88.127.148:1994"
const LIVE = 1;
const STAGGING = 0;
const env = LIVE
export { ServerAPIUrl, LIVE, STAGGING, env, ServerBaseAPIUrl }